import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import * as moment from "moment";
import Constants from "../../../Action/Constants";
import { TableComponent } from "../../Partials/Table/TableComponent";
// import { SubscriptionIcon } from "../../Partials/Subscription/SubscriptionIcon";
import Select from "../../Partials/Material/Select";
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { EmailAccountInterface } from "../../../Entity/Entities/EmailAccount/EmailAccountInterface";
import MailsWillMount from "../../../Middleware/Middlewares/MailsWillMount";
import { User } from "../../../Entity/Entities/Person/Role/Roles/User";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import { EmailAccountCreate } from "../../Partials/Dialog/EmailAccountCreate";

class Mails extends Component {
  protected middlewares: MiddlewareInterface[] = [
    MailsWillMount
  ];
  protected emailAccountCreate = null;

  public state = {
    renderEmailField: false,
    isPromptOpen: false,
    entity: null,
    defaultEmailAccountId: null,
    valueFilter: null
  }

  constructor(public props) {
    super(props);
    if(sessionStorage.getItem('value-email-account') || this.props.app.emailAccounts[0]) {
      this.props.dispatch({
        type: Constants.PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_START,
        payload: {
          emailAccount: sessionStorage.getItem('value-email-account') ?  sessionStorage.getItem('value-email-account') : this.props.app.emailAccounts[0].id
        }
      });
    }

    this.changeEmailAccount = this.changeEmailAccount.bind(this);
    this.emailAccountValue = this.emailAccountValue.bind(this);
  }

  public componentWillReceiveProps(nextProps) {
    let emailAccounts = nextProps.app.emailAccounts.filter(emailAccount => {
      return emailAccount.removed === false;
    });

    emailAccounts = emailAccounts
    .filter((emailAccount) => {
      return emailAccount.isAgencyAccount();
    });

    const defaultMailAccount = sessionStorage.getItem('value-email-account') ? +sessionStorage.getItem('value-email-account') : emailAccounts[0] ? emailAccounts[0].id : null;
    this.setState({valueFilter: defaultMailAccount ? defaultMailAccount : null });
  }

  public isUser = (): boolean =>  {
    return this.props.app.session && this.props.app.session.user && this.props.app.session.user.role && this.props.app.session.user.role.getRoleId() === User.contactRoleId;
  }

  public createAccount = (): void => {
    this.openDialog();
  }

  public openDialog = () => {
    this.props.dispatch({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_TOGGLE_DIALOG,
      payload: {
        isDialogOpen: true
      }
    });
  }

  public changeEmailAccount(id) {
    this.props.dispatch({
      type: Constants.PAGE_MAIL_ACTIVE_MAIL_ACCOUNT_START,
      payload: {
        emailAccount: id
      },
      onSuccess: () => {
        sessionStorage.setItem('value-email-account', id);
      }
    });
  }

  public emailAccountValue(event) {
    this.setState({valueFilter: event.target.value});
  }

  protected getMailsAccount (filterAgencyAccounts: boolean) {
    let emailAccounts: EmailAccountInterface[] = this.props.app.emailAccounts.filter(emailAccount => {
      return emailAccount.removed === false;
    });

    if (filterAgencyAccounts === true) {
      emailAccounts = emailAccounts
      .filter((emailAccount: EmailAccountInterface) => {
        return emailAccount.isAgencyAccount() === filterAgencyAccounts;
      });
    }
    return emailAccounts;
  }

  public getDialogTitle = (): string => {
    if (this.props.component.isUpdating === true) {
      return this.trans("update-email-account");
    }

    return this.trans("add-email-account");
  }

  public closeDialog = () => {
    this.props.dispatch({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_TOGGLE_DIALOG,
      payload: {
        isDialogOpen: false,
        isUpdating: false
      }
    });
  }

  public getDialogContent = (): any => {
    return (
      <EmailAccountCreate
        {...this.props}
        ref={ref => this.emailAccountCreate = ref}
        onSave={this.addEmailAccount}
        onCancel={this.closeDialog}
      />
    );
  }

  public addEmailAccount = (imapCredentials): any => {
    this.props.dispatch({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_START,
      payload: {
        imapCredentials: imapCredentials
      },
      onSuccess: () => {
        this.emailAccountCreate.setState({
          isSaving: false
        });
      },
      onError: err => {
        this.emailAccountCreate.setState({
          isSaving: false,
          errors: err.fields.length === 0 ? [err.message, ...this.emailAccountCreate.state.errors] : [...this.emailAccountCreate.state.errors]
        });
      }
    });
  }

  protected getMails() {
    if(this.props.mails.emails ){
      return this.props.mails.emails.map((mail) => {
        if (!mail) {
          return;
        }
        return (
          <TableRow hover key={mail.id} className={`clickable-entity mails-table ${ mail.eventTypeId === 1 ? 'mail-received' : 'mail-sent'}`}>
            <TableCell style={{width: "24px"}}> <div className="icon icon-ic-email"></div></TableCell>
            <TableCell>{mail.content.letter.from[0].address}</TableCell>
            <TableCell>{mail.content.letter.text}</TableCell>
            <TableCell style={{width: "60px"}}>
            <div style={{display: "inline-flex", flexDirection: "column"}}>
              <span style={{fontSize: "16px"}}>{moment(mail.content.letter.date).format('L')}</span>
              <span style={{fontSize: "13px"}}>
                {moment(mail.content.letter.date).format('h:mm:ss a')}
              </span>
            </div>
            </TableCell>
            <TableCell style={{width: "80px"}}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => {
                   this.redirect(`/app/mails/${mail.emailAccountId}/mail/${mail.id}`)
                }}
              >
                {this.trans("view")}
              </Button>
            </TableCell>
          </TableRow>
        );
      });
    } else {
      return [];
    }

  }

  public render() {
    return (
      <div className="state-app">
        <div className="box box-full component-mails has-general-page-header">
          <div className="component-header no-paddings">
            <div style={{padding: "0 40px", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <h1 style={{padding: "24px 0"}} onClick={this.getMails}>{this.trans("mail-page-title")}</h1>
              <div style={{display: "flex", alignItems: "center"}}>
                { this.getMailsAccount(true).length === 0 &&
                  <Button
                    style={{ display: this.isUser() ? "none" : "block", height: "40px" }}
                    onClick={this.createAccount}
                    variant="contained"
                    color="primary"
                  >
                    {this.trans("add-email-account")}
                  </Button>
                }
                <Select
                  className="form-element form-input correct-label-position"
                  style={{marginLeft: "25px", width: "250px"}}
                  value={this.state.valueFilter}
                  onChange={this.emailAccountValue}
                  htmlFor="email"
                  label={this.trans("label-email")}
                  name="email" 
                  id="email"
                >
                  {
                    this.getMailsAccount(true)
                      // .filter((bankAccount: BankAccountInterface) => bankAccount.removed === false)
                      .map((emailAccount: EmailAccountInterface, key: number) => (
                        <MenuItem
                          key={key}
                          value={emailAccount.id}
                          className="filter-payment-item"
                          onClick={() => this.changeEmailAccount(emailAccount.id)}
                        >
                          <div className='filter-name'>{`${emailAccount.imapUser}`}</div>
                        </MenuItem>
                      )
                    )
                  }
                </Select>
              </div>
            </div>
          </div>

          <div className="component-wrapper no-margin-top">
            <div>
              <TableComponent
                {...this.props}
                paginator={{
                  name: "Mails",
                  path: this.props.app.paginator
                }}
                dispatch={this.props.dispatch}
                rows={this.getMails()}
                subtitle={this.isUser() ? this.state.valueFilter ? this.trans("email-box-page-no-emails-list-admin-active") : this.trans("email-box-page-no-emails-list-manager") : this.state.valueFilter ? this.trans("email-box-page-no-emails-list-admin-active") : this.trans("email-box-page-no-emails-list-admin")}
                ignoreFirstCellClick={true}
              />
            </div>
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.getDialogTitle()}
          content={this.getDialogContent()}
          openLeavePrompt={this.props.component.isDialogOpen}
          onClose={this.closeDialog}
          onlyPositiveButton={false}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    mails: state.mails,
    component: state.emailAccounts,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  Mails
);
